import ReportTypes from "../../../helpers/constants/ReportTypes";
import ImgTimeValues from "../../../helpers/constants/ImgTimeValues";
import AppConfig from "../../../helpers/constants/AppConfig";
import ApiUrls from "../../../helpers/urls/ApiUrls";
import store from "../../../redux/store";

export const getGraphObject = (data) => {
  const type = ReportTypes.filter((rt) => rt.value === data.item)[0];
  const siteList = store.getState().site_list;
  const site = siteList.filter((s) => s.mgmtip === data.ip)[0];
  let item = data.item, period = data.period;
  const timeRange = ImgTimeValues.filter((itv) => itv.value === data.period)[0];
  const dateString = new Date().toTimeString();

  let obj = {
    ...data,
    ...type,
    site,
    timeRange
  }

  if (data.item === "statistic") {
    obj = {
      ...obj,
      id: `s-${dateString}`
    }
  } else {
    if (type.type === "chart") {
      obj = {
        ...obj,
        item: item === "disk_pie" ? "disk" : item,
        period: item === "disk_pie" ? "day" : period,
        id: `g-${dateString}`
      }
    } else {
      obj = {
        ...obj,
        id: `g-${dateString}`,
        src: `${AppConfig.api_baseURL}${ApiUrls.reports.img}?ip=${data.ip}&domain&item=${item}&period=${period}`
      }
    }
  }
  return obj;
}